import React from "react";

import "./style.scss";

const Operator = ({ children }) => (
  <div className="operator-wrapper">
    <div className="operator-content">{children}</div>
  </div>
);

export default Operator;
